import { useSelector } from "react-redux";
import { useState } from "react";
import UpdateContactModal from "./userInfoComponents/UpdateContactModal";

const ContactInfo = () => {
    const user = useSelector((state) => state.auth.user);
    const [isModalOpen, setIsModalOpen] = useState(false);

    if (!user) {
        return null;
    }

    const handleUpdateClick = () => {
        setIsModalOpen(true);
    };

    const handleCloseModal = () => {
        setIsModalOpen(false);
    };

    return (
        <>
            <div className="text-left mb-4">
                <h1 className="text-2xl font-sans font-normal text-charcoal">Contact Information</h1>
            </div>
            
            <div className="w-full bg-ivory p-6 rounded-lg shadow-md">
                <ul className="font-sans text-md text-gray-700 space-y-2"> 
                    <li className="capitalize"><span className="font-semibold">Company Name:</span> {user.company}</li>
                    <li><span className="font-semibold">E-mail:</span> {user.email}</li>
                    <li className="capitalize"><span className="font-semibold">Contact Person:</span> {user.name}</li>
                </ul>
                <div className="text-right mt-4">
                    <button 
                        className="px-4 py-2 bg-charcoal text-white rounded-lg text-sm font-sans hover:bg-teal"
                        onClick={handleUpdateClick}
                    >
                        Update Contact
                    </button>
                </div>
            </div>

            {isModalOpen && <UpdateContactModal user={user} onClose={handleCloseModal} />}
        </>
    );
};

export default ContactInfo;
